import React from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Link } from "react-router-dom";
import Configuration from "../../../config";
import { translations } from "../../../config";

import Access from "../../../components/Access";
import Logo from "./Logo";
import OrderableQuestionnaires from "./OrderableQuestionnaires";

/**
 * Komponente um statische Inhalte auszugeben
 */
class ExecutableQuestionnaires extends React.Component
{
	render()
	{
		const { questionnaires } = { ...this.props };
		const basicPriceInfo = !!this.props.basicPriceInfo;
		
		return (
			// Prüfung um die Transition zu sehen
			questionnaires && Object.keys( questionnaires ).length > 0 &&
			<Access permissions={[ "create_survey" ]}
			        errorContent={
				        <Access permissions={[ "create_questionnaire" ]}>
					        {questionnaires.length > 0 && <OrderableQuestionnaires questionnaires={questionnaires} statusInfo/>}
				        </Access>
			        }>
				<div className={"col s12 unset-padding"}>
					<h3>Verfügbare Einstufungsassistenten</h3>
					<div className={"col s12 light-blue unset-padding margin-top relative"}>
						<div className={"tLabel tRight secondary-color white-text"}>alle Preise zzgl. 19% USt.</div>
						<ReactCSSTransitionGroup
							component={React.Fragment}
							transitionName="easeIn"
							transitionAppear={true}
							transitionAppearTimeout={500}
							transitionEnter={false}
							transitionLeave={false}>
							<div className={"col s12 surveyButtons"}>
								{
									questionnaires !== null && Object.keys( questionnaires ).length > 0 &&
									Object.keys( questionnaires )
										.sort( ( a_key1, a_key2 ) => questionnaires[ a_key1 ].sort_id - questionnaires[ a_key2 ].sort_id )
										.map(
											( a_key ) =>
											{
												const link = questionnaires[ a_key ];
												const props = typeof link.isActive !== "undefined" && { className: "inactive" };
												const price = link.price > 0
													? ( parseFloat( link.price ) ).toLocaleString( Configuration.location, Configuration.priceString )
													: "NaN";
												
												return link.active === "1" &&
													<div className={"col s12 m6 l3 xl2"} key={`questionnaire_id_${link.id}`}>
														<div className={"col s12 white margin-bottom tCenter"}>
															<div className={"priceLabel"}>{link.description}</div>
															<Link key={`questionnaire_open_id_${link.id}`}
															      to={`${translations.de_DE.routes.survey}?id=${link.id}`}
															      className={"btn btn-rounded btn-pulse svg"}
															      title={"Recherche zahlungspflichtig starten"}
															>
																<Logo topText={link.law} bottomText={link.title} id={link.id} props={props}/>
															</Link>
															<div className={"price big-block"}>
																<div className={"cleared"}/>
																<span className={"value small"}>
																	{price}
																</span>
																<span className={"additional"}>Euro
																	{
																		basicPriceInfo &&
																		<span className="form-element-required secondary-color-text"> *</span>
																	}
																</span>
															</div>
														</div>
													</div>;
											}
										)
								}
								{
									basicPriceInfo &&
									<label className={"col s12 margin-bottom secondary-color-text"}>
										<span className="form-element-required secondary-color-text">* </span>
										Nutzungsabhängige Gebühr pro durchgeführter Richtlinienrecherche, nur in Verbindung mit der monatlichen Imera Grundgebühr von 19,99
										Euro. Alle Preise verstehen sich zuzüglich 19% USt.
									</label>
								}
							</div>
						</ReactCSSTransitionGroup>
					</div>
					<label>Recherche durch Klick auf den Assistenten starten</label>
					<div className={"cleared spacer"}/>
				</div>
			</Access>
		);
		
	} // function render()
	
} // class

ExecutableQuestionnaires.propTypes = {
	questionnaires: PropTypes.object.isRequired,
	basicPriceInfo: PropTypes.bool
};

export default ExecutableQuestionnaires;